import type { CreatedByType } from 'app/types/modules';
import { ROLES_GUID } from 'core/utils/user';

/** Los ítems editoriales no muestran autor; sin autor tampoco hay nada que mostrar (TAN-11214). */
export function hasVisibleAuthor(createdBy?: CreatedByType): boolean {
  return Boolean(createdBy) && createdBy.role_guid !== ROLES_GUID.EDITORIAL;
}
